import "../sass/main.scss";

//import "slick-carousel/slick/slick";
import "./jquery.vnm.percentWithinViewport.min";

import "./script-modal";
import "./_sprite";
import "./script-components";
//import "./masonry";

//let pattern_row_before = '<svg data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 591.24 145.21"><path d="m0,145.21h591.24s-.23,0-.23,0c-22.78,0-43.89-6.12-63.51-17.76l-18.04-10.6c-37.37-22.16-79.96-33.84-123.33-33.84H0s0,62.21,0,62.21Z" style="fill: #fff; stroke-width: 0px;"/><g><path d="m.34,0l57.21.71h.29s14.02.18,14.02.18h.18s14.13.18,14.13.18c32.27.38,62.27,10.77,84.48,29.25,16.89,14.06,28.65,31.96,34.71,52.61h-2.08c-6-20.04-17.48-37.4-33.9-51.07-18.84-15.68-43.4-25.43-70.18-28.07,21.05,4.28,40.21,13.18,55.59,26.04,16.83,14.08,28.68,32.16,34.95,53.1h-2.09c-6.2-20.32-17.77-37.88-34.14-51.57C135.07,15.94,111.09,6.31,84.94,3.64c43.76,9.04,76.76,38.25,89.27,79.29h-2.09C158.29,38.44,119.85,8.22,69.78,3.38c20.27,4.14,38.51,12.74,53.66,25.46,16.86,14.16,28.89,32.61,35.41,54.09h-2.09c-6.45-20.86-18.2-38.78-34.61-52.56C103.79,14.95,80.8,5.67,55.12,3.2c19.91,4.11,37.85,12.6,52.78,25.14,16.92,14.21,29.05,32.85,35.66,54.59h-2.1c-6.53-21.13-18.38-39.24-34.85-53.06C88.46,14.62,65.76,5.44,40.44,3c42.87,8.87,75.19,38.06,87.85,79.93h-2.1C112.21,37.51,74.6,7.37,25.49,2.78c42.62,8.83,74.92,38.15,87.56,80.15h-2.08C97.01,37.39,59.44,7.12,10.71,2.58c42.33,8.83,74.58,38.27,87.15,80.35h-2.09C82.27,38.55,46.45,8.58,0,2.82V0h.34Z" style="fill: #e9dabe; stroke-width: 0px;"/><path d="m82.68,82.93h-2.09C68.67,43.3,38.97,15.09,0,5.35v-2.06c40.09,9.84,70.61,38.83,82.68,79.64Z" style="fill: #e9dabe; stroke-width: 0px;"/>     <path d="m67.54,82.93h-2.08c-6.64-22.4-18.95-41.49-36-55.65C20.63,19.94,10.73,14.11,0,9.85v-2.14c11.21,4.36,21.54,10.4,30.74,18.03,17.5,14.53,30.09,34.16,36.8,57.19Z" style="fill: #e9dabe; stroke-width: 0px;"/>     <path d="m52.4,82.93h-2.08c-6.61-22.65-19.02-41.94-36.21-56.17C9.67,23.08,4.95,19.79,0,16.88v-2.3c5.42,3.09,10.56,6.64,15.38,10.64,17.65,14.6,30.35,34.43,37.02,57.71Z" style="fill: #e9dabe; stroke-width: 0px;"/>     <path d="m37.28,82.93h-2.08C28.79,60.57,16.72,41.46,0,27.26v-2.61s.03.02.04.03c17.81,14.68,30.6,34.71,37.24,58.25Z" style="fill: #e9dabe; stroke-width: 0px;"/>     <path d="m20.09,82.93C15.86,67.89,9.06,54.31,0,42.7v-3.21c10.12,12.38,17.63,27.08,22.17,43.44h-2.08Z" style="fill: #e9dabe; stroke-width: 0px;"/>   </g> </svg>';
//let pattern_row_before_2 = '<svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 591.24 62.22">   <path d="m0,0v62.21s591.24,0,591.24,0h-.23c-22.77,0-43.89-6.12-63.51-17.76l-18.04-10.6C472.09,11.69,429.5.01,386.13.01H0Z" style="fill: #f4f3d9; stroke-width: 0px;"/> </svg>';
//let pattern_row_after = '<svg preserveAspectRatio="none" viewBox="0 0 1920 37" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1920 17.507C1920 17.507 1553.08 61.3663 1030.32 17.5071C507.548 -26.3521 440.675 36.75 -3.05272e-05 27.2575L-3.29101e-05 0.000166905L1920 -9.46445e-07L1920 17.507Z" fill="currentColor"/></svg>';
jQuery(document).ajaxComplete(function () {
    initialiseMain();
});
jQuery(window).resize(function () {
    stickToSides();
    stickyTop();
});

jQuery(document).ready(function () {
    initialiseMain();
    //initialiseFooter();
    stickToSides();
    //addPattern();
    initialiseParallax();
    initialiseDelayTransitions();
    //delayTransitions();
    stickyTop();
    //initBackToTop();
});

jQuery(window).scroll(function() {
    //runParallax();
    //delayTransitions();
    stickyTop();
});

function initBackToTop(){
    let button = jQuery('<span class="back-to-top use-svg ise-icon use-icon-back-to-top"></span>').appendTo('footer');
    button.on('click',function(){
        jQuery("html, body").animate({ scrollTop: 0 }, "fast");
        return false;
    });
}

function initialiseMain() {
    jQuery('.menu-btn').click(function () {
        jQuery('.menu-btn').toggleClass('is-active');
        jQuery('body').toggleClass('menu-is-active');
    });

    /*
     * Pouvoir cliquer sur l'ensemble d'une carte
     */
    jQuery('.js-card').click(function () {
        let $link = jQuery(this).find('.js-button');
        let $href = $link.attr('href');
        let $target = $link.attr('target');
        if( $target == "_blank" )
            window.open($href, '_blank');
        else
            window.location.href = $href;
    }).mouseenter(function () {
        jQuery(this).find('.js-button').addClass('is-active');
    }).mouseleave(function () {
        jQuery(this).find('.js-button').removeClass('is-active');
    });

    jQuery('.card:not(.card-sequence)').hover(function () {
        jQuery(this).find('.button, .button-link, .js-button').toggleClass('is-hover');
    });

    jQuery('.card-presentation').each(function (index) {
        if ((index + 1) % 2 === 0) {
            // Appliquer un style aux éléments pairs
            jQuery(this).addClass('card-presentation-reverse');
        }
    });

    // listes déroulantes :
    jQuery('.toggle-block').each(function () {
        let $element= jQuery(this);
        let $btn = jQuery(this).find('> .toggle-block__btn');

        $btn.click(function(){
            $element.toggleClass('is-active');
        });
    });

    jQuery('.nr-js-filters-mobile').click(function(){
        jQuery(this).parent().toggleClass('active');
    });
}

function inputChange() {
    jQuery('input[type="radio"]').change(function () {
        jQuery(this).parent().toggleClass('is-active');
    });
}

function addPattern() {
    jQuery("#page-content > .container > .wpb-content-wrapper > .vc_row[data-vc-full-width='true']").each(function(index){
        if( index != 0 ){
            let $element = jQuery(this);

            // current bg
            let $current_bg = 'default';
            let $element_class = $element.attr('class').split(' ');
            for (let i = 0; i < $element_class.length; i++) {
                if ($element_class[i].slice(0, 9) === 'bg-color-') {
                    $current_bg = $element_class[i].slice(9);
                }
            }

            // prev bg
            let $prev_bg = 'default';
            let $prevRow = $element.prevAll('.vc_row:not(.vc_clearfix)').first();
            let $prev_class = $prevRow.attr('class').split(' ');
            let $prev_pattern = 'left';

            for (let i = 0; i < $prev_class.length; i++) {
                if ($prev_class[i].slice(0, 9) === 'bg-color-') {
                    $prev_bg = $prev_class[i].slice(9);
                }
                if ($prev_class[i].slice(0, 20) === 'pattern-before-right') {
                    $prev_pattern = 'right';
                }
            }



            if( $current_bg != $prev_bg )
            {
                $element.addClass('pattern-before');

                if($prev_bg != 'default')
                    $element.addClass('pattern-before-under-color-'+$prev_bg);


                //if( index%2 == 0 ){
                if( $prev_pattern == 'left' ){
                    $element.addClass('pattern-before-right');
                }
            }

        }
    });

    jQuery('.pattern-before:not(.pattern-before-is-loaded)').each(function () {
        let $element =  jQuery(this);
        let pattern_use = pattern_row_before;

        if( $element.hasClass('pattern-before-2') ){
            pattern_use = pattern_row_before_2;
        }

        let elt_class = jQuery(this).attr('class').split(' ');
        let pattern_color = 'color-primary';
        let pattern_bg_color = '';
        for (let i = 0; i < elt_class.length; i++) {
            if (elt_class[i].slice(0, 8) === 'bg-color') {
                pattern_color = 'block-pattern-before-color-' + elt_class[i].slice(9);
            }

            if (elt_class[i].slice(0, 26) === 'pattern-before-under-color') {
                pattern_bg_color = 'bg-color-' + elt_class[i].slice(27);
            }
        }

        let block = jQuery('<div class="block-pattern block-pattern-before ' + pattern_color + ' ' + pattern_bg_color + '">' + pattern_use + '</div>').prependTo(jQuery(this));
        let height = block.height();

        jQuery(this)
            .css('overflow', 'visible')
            .css('position', 'relative');

        if (!jQuery(this).hasClass('pattern-before-no-margin'))
            jQuery(this).css('margin-top', height);

        jQuery(this).addClass('pattern-before-is-loaded');

        // patternBgColor(jQuery(this), block);
    });

    jQuery('.pattern-after:not(.pattern-after-is-loaded)').each(function () {
        let pattern_use = pattern_row_after;

        let elt_class = jQuery(this).attr('class').split(' ');
        let pattern_color = 'color-primary';
        let pattern_bg_color = '';
        for (let i = 0; i < elt_class.length; i++) {
            if (elt_class[i].slice(0, 19) === 'pattern-after-color') {
                pattern_color = elt_class[i].slice(14);
            }

            if (elt_class[i].slice(0, 22) === 'pattern-after-bg-color') {
                pattern_bg_color = elt_class[i].slice(14);
            }
        }

        let block = jQuery('<div class="block-pattern block-pattern-after ' + pattern_color + ' ' + pattern_bg_color + '">' + pattern_use + '</div>').appendTo(jQuery(this));
        let height = block.height();

        jQuery(this)
            .css('overflow', 'visible')
            .css('position', 'relative');

        if (!jQuery(this).hasClass('pattern-after-no-margin'))
            jQuery(this).css('margin-bottom', height);

        jQuery(this).addClass('pattern-after-is-loaded');

        //patternBgColor(jQuery(this), block);
    });

}

function patternBgColor(parent, block) {
    if (jQuery(parent).hasClass('bg-color-primary')) {
        block.addClass('block-pattern-bg-color-primary');
    } else if (jQuery(parent).hasClass('bg-color-secondary')) {
        block.addClass('block-pattern-bg-color-secondary');
    } else if (jQuery(parent).hasClass('bg-color-tertiary')) {
        block.addClass('block-pattern-bg-color-tertiary');
    } else if (jQuery(parent).hasClass('bg-color-white')) {
        block.addClass('block-pattern-bg-color-white');
    } else if (jQuery(parent).hasClass('bg-color-black')) {
        block.addClass('block-pattern-bg-color-black');
    } else if (jQuery(parent).hasClass('bg-color-neutral-1')) {
        block.addClass('block-pattern-bg-color-neutral-1');
    }
}

function stickToSides() {
    let $minWidth = 1440;
    let $maxWidth = 2300;
    let $window = jQuery(window);

    jQuery('.stickToLeft').each(function () {
        let $element = jQuery(this);
        let $offset = $element.offset().left;
        let $left = $offset;
        let $newWidth = $width + $left;
        let $css = '';

        if ($window.width() > $minWidth && $window.width() < $maxWidth) {
            $css = 'margin-left:-'+ $offset +'px;width:'+ $newWidth +'px';

            if($element.is('.stickToLeftKeepContentWidth')){
                $css = $css + ';padding-left:'+$offset+'px !important';
            }

            $element.css('cssText', $css);

        }
        else {
            $element.css('margin-left', '');
            $element.css('padding-left', '');
        }
    });

    jQuery('.stickToRight').each(function () {
        let $element = jQuery(this);
        let $offset = $element.offset().left;
        let $width = $element.outerWidth();
        let $right = $window.width() - ($offset + $width);
        let $newWidth = $width + $right;
        let $css = '';

        if ($window.width() > $minWidth && $window.width() < $maxWidth) {
            $css = 'margin-right:-'+ $right +'px;width:'+ $newWidth +'px';

            if($element.is('.stickToRightKeepContentWidth')){
                $css = $css + ';padding-right:'+$right+'px !important';
            }

            $element.css('cssText', $css);
        }
        else{
            $element.css('cssText', '');
        }
    });
}

function initialiseDelayTransitions(){
    jQuery('.js-delay-transition').each(function(){
        let $element = jQuery(this);
        $element.addClass('js-delay-transition-init');
    });
}
function delayTransitions(){
    jQuery('.js-delay-transition-init').percentWithinViewport();
    jQuery('.js-delay-transition-init').each(function(){
        let $element = jQuery(this);
        let $percent = $element.attr('data-percent-viewport');
        if($percent > 40){
            $element.addClass('js-delay-transition-active');
        }
        else if( $element.is('.js-delay-transition-can-reverse') ){
            $element.removeClass('js-delay-transition-active');
        }
    });
}

function initialiseParallax(){
    jQuery('.parallax').each(function(){
        let $element = jQuery(this);
        $element.parent().css('overflow','hidden');
    });
}
function runParallax(){
    let minWidth = 768;
    let $window = jQuery(window);

    if ($window.width() < minWidth) {
        jQuery('.parallax').css({
            '-webkit-transform': '',
            '-moz-transform': '',
            '-ms-transform': '',
            '-o-transform': '',
            'transform': ''
        });
        return;
    }

    jQuery('.parallax').percentWithinViewport();
    jQuery('.parallax').each(function(){
        let $element = jQuery(this);
        let translateX = '';
        let translateY = '';
        let $percent = $element.attr('data-percent-viewport');

        if($element.is('.parallax-x')){
            let $slowX = 9;
            let $reverseX = '';
            let $translateXVal = '';

            if($element.is('.parallax-x-slow-1')) $slowX = 3;
            else if($element.is('.parallax-x-slow-2')) $slowX = 6;
            else if($element.is('.parallax-x-slow-3')) $slowX = 9;
            else if($element.is('.parallax-x-slow-4')) $slowX = 12;
            else if($element.is('.parallax-x-slow-5')) $slowX = 15;

            if($element.is('.parallax-x-reverse')) $reverseX = '-';

            if( ($element.offset().top) > jQuery(window).scrollTop() ) {
                $translateXVal = (100 - $percent) / $slowX;
            }
            else{
                $translateXVal = 0;
            }

            translateX = 'translateX(' + $reverseX + $translateXVal + '%)';
        }

        if($element.is('.parallax-y')){
            let $slowY = 9;
            let $reverseY = '';
            let $translateYVal = '';

            if($element.is('.parallax-y-slow-1')) $slowY = 3;
            else if($element.is('.parallax-y-slow-2')) $slowY = 6;
            else if($element.is('.parallax-y-slow-3')) $slowY = 9;
            else if($element.is('.parallax-y-slow-4')) $slowY = 12;
            else if($element.is('.parallax-y-slow-5')) $slowY = 15;

            if($element.is('.parallax-y-reverse')) $reverseY = '-';

            if( ($element.offset().top) > jQuery(window).scrollTop() ) {
                $translateYVal = (100 - $percent) / $slowY;
            }
            else{
                $translateYVal = 0;
            }

            translateY = 'translateY(' + $reverseY + $translateYVal + '%)';
        }

        if( translateX || translateY ){
            $element.css({
                '-webkit-transform': translateX +' '+translateY ,
                '-moz-transform': translateX +' '+translateY,
                '-ms-transform': translateX +' '+translateY,
                '-o-transform': translateX +' '+translateY,
                'transform': translateX +' '+translateY
            });
        }
    });
}

function stickyTop(){
    let $stickyContainer = jQuery('.sticky-header');
    let $window = jQuery(window);
    let $body = jQuery('body');
    let $docViewTop = $window.scrollTop();
    let $padding = 0;


    /*if( $window.width() < 992 ){
        $body.css('padding-top','');
        $body.removeClass('js-sticky-on');
        $stickyContainer.removeClass('sticky--scrolled');
        return false;
    }*/

    if( $stickyContainer.length > 0 )
    {
        if( !$body.is('.js-sticky-active'))
        {
            if(isInvisibleInWindow($stickyContainer, 100)){
                $stickyContainer.addClass('sticky--scrolled');
                $body.addClass('js-sticky-active');
                $stickyContainer.attr('data-initial-height', $stickyContainer.outerHeight() );

                if( $body.is('.header__color-dark') ){
                    $body.addClass('js-header-switch-color');
                }
            }
        }

        if( $docViewTop > 0 && $body.is('.js-sticky-active') ){
            $body.addClass('js-sticky-on');

            //if( !$body.is('.header_template_template1') ){
            $padding = $stickyContainer.attr('data-initial-height');
            $body.css('padding-top',$padding);
            //}

            if( $body.is('.js-header-switch-color') ){
                $body.removeClass('header__color-dark');
            }
        }
        else if( $body.is('.js-sticky-active') ){
            $body.removeClass('js-sticky-on');

            if( $body.is('.js-header-switch-color') ){
                $body.addClass('header__color-dark');
            }

            //if( !$body.is('.header_template_template1') ){
            $padding = $stickyContainer.attr('data-initial-height');
            $body.css('padding-top',$padding + 'px');
            //}
        }
    }
}

function isInvisibleInWindow(elem,offset=0){
    let $elem = jQuery(elem);
    let $window = jQuery(window);

    let docViewTop = $window.scrollTop();
    let docViewBottom = docViewTop + $window.height();

    let elemTop = $elem.offset().top;
    let elemBottom = elemTop + $elem.height();

    return ((elemTop >= docViewBottom) || ((elemBottom + offset) <= docViewTop));
}